import React from "react"
import { FieldProps } from "@rjsf/utils"

import WeeklyScheduleView from "./WeeklyScheduleView"
import { WeeklySchedule } from "./raffleSchedule"
import {
  buildWeeklyScheduleViewModel,
  listTimeZones,
  withScheduleDefaults,
} from "./weeklyScheduleViewModel"

// Thin RJSF container: owns form state, delegates all presentation to WeeklyScheduleView.
export const WeeklyScheduleField = ({
  formData,
  onChange,
  disabled,
  readonly,
  formContext,
}: FieldProps<WeeklySchedule | undefined>) => {
  const model = React.useMemo(() => buildWeeklyScheduleViewModel(formData), [formData])
  const timeZones = React.useMemo(() => listTimeZones(model.value.timezone), [model.value.timezone])

  const handleChange = React.useCallback(
    (patch: Partial<WeeklySchedule>) => onChange({ ...withScheduleDefaults(formData), ...patch }),
    [formData, onChange],
  )
  const handleCancel = React.useCallback(
    () => onChange({ ...withScheduleDefaults(formData), enabled: false, paused: false }),
    [formData, onChange],
  )

  return (
    <WeeklyScheduleView
      value={model.value}
      status={model.status}
      nextPublishLabel={model.nextPublishLabel}
      nextEndLabel={model.nextEndLabel}
      timeZones={timeZones}
      errors={model.errors}
      raffleDisabled={Boolean(formContext?.raffleDisabled)}
      disabled={disabled}
      readOnly={readonly}
      onChange={handleChange}
      onCancel={handleCancel}
    />
  )
}

export default WeeklyScheduleField
